import { useSelector } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { convertBase64ToJSON } from 'zync-common/queryParameters';
import { Buffer } from 'buffer';

const useUserIdAuthAndSearchQuery = () => {
  const userIdAuth = useSelector((st) => st.auth?.user?.userId);

  const queryParams = new URLSearchParams(window.location.search);
  const base64EncodedUserData = queryParams.get('q');
  const userDataFromQp = base64EncodedUserData
    ? convertBase64ToJSON(Buffer, base64EncodedUserData)
    : null;

  const userId =
    queryParams.get('emailAddress') ||
    userDataFromQp?.e ||
    localStorage.getItem('emailAddress') ||
    userIdAuth;

  return userId;
};

const useDistinctId = () => {
  const params = useParams();
  const userId = useUserIdAuthAndSearchQuery();
  const isAnonymous = userId === 'anonymous@zync.ai';
  const meetingSeriesIdFromState = useSelector(
    (state) => state.meetingState.meetingSeriesId
  );

  if (isAnonymous) {
    const meetingSeriesId = meetingSeriesIdFromState || params.meetingSeriesId;

    if (meetingSeriesId) {
      return `${userId}_${meetingSeriesId}`;
    } else {
      return userId;
    }
  }

  return userId;
};

export const useTrackActivity = (namespace) => {
  const userDistinctId = useDistinctId();

  const track = useCallback(
    (message, data = {}) =>
      mixpanel.track(namespace ? `${namespace} ${message}` : message, {
        distinct_id: userDistinctId,
        ...data,
      }),
    [userDistinctId, namespace]
  );

  return track;
};
